

import { useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";


const DEAD_SESSION_CODES = [
    'login_required',
    'consent_required',
    'missing_refresh_token',
    'invalid_grant',          // "Unknown or invalid refresh token."
];

export const isDeadSessionError = (e) =>
    DEAD_SESSION_CODES.includes(e?.error) ||
    /invalid refresh token|missing refresh token/i.test(e?.message || '');


export const recoverFromDeadSession = (loginWithRedirect) => {
    const KEY = 'auth_recover_at';
    let last = 0;
    try { last = Number(sessionStorage.getItem(KEY)) || 0; } catch (e) { /* ignore */ }
    if (Date.now() - last < 30000) {
        console.error('[AUTH] recovery already attempted <30s ago; not redirecting again');
        return false;
    }
    try { sessionStorage.setItem(KEY, String(Date.now())); } catch (e) { /* ignore */ }
    try {
        Object.keys(localStorage)
            .filter(k => k.startsWith('@@auth0spajs@@'))
            .forEach(k => localStorage.removeItem(k));
    } catch (e) { /* ignore */ }
    console.warn('[AUTH] saved session is no longer valid; redirecting to login');
    loginWithRedirect();
    return true;
};

export const useAuth = () => {
    const auth = useAuth0();
    const { getAccessTokenSilently, loginWithRedirect } = auth;


    const safeGetAccessTokenSilently = useCallback(async (...args) => {
        try {
            return await getAccessTokenSilently(...args);
        } catch (e) {
            if (isDeadSessionError(e)) recoverFromDeadSession(loginWithRedirect);
            throw e;
        }
    }, [getAccessTokenSilently, loginWithRedirect]);

    return { ...auth, getAccessTokenSilently: safeGetAccessTokenSilently };
};